import api from '@/apis/di/accountingObjectAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('accountingObject', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_accounting_object',
    field: {
      key: 'accounting_object_id',
      code: 'accounting_object_code',
      name: 'accounting_object_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Xuất khẩu grid Danh sách cán bộ
   * @param {*} context
   * @param {*} payload
   * @returns
   * TVANH 10.02.2023
   */
  async exportEmployeeList(context, payload) {
    return await api.exportEmployeeList(payload);
  },

  /**
   * Load danh sách (override lại để chỉnh lại API)
   */
   async loadAccountingObject(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.getListAccountingObject(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }
    
    context.commit('updatePayloadNextBack', {...payload});
    if (res && !payload.isNextBack) {
      context.commit('setPaging', res);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
